
import Vue from "vue";
export default Vue.extend({
  name: "imam-hussain-features",

  data() {
    return {
      features: [
        {
          name: "زیارت نیابتی امام حسین (علیه السلام)",
          desc: "ما نایب الزیاره شما هستیم",
          image: require("@/assets/img/hazratMasoomeDetails.png"),
        },
      ],
    };
  },
  methods: {
    handelGoRegister() {
      this.$router.push({
        name: "imam-hussain-ziarat-register",
      });
    },
  },

  components: {},
});
